import { getMenuItems } from 'src/services'
import { useQuery } from '@tanstack/react-query'

export const menuQueryKeys = ['states']

export function useMenuQuery() {
  return useQuery({
    queryKey: menuQueryKeys,
    queryFn: getMenuItems,
    staleTime: Infinity,
  })
}
